var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',{attrs:{"id":"main"}},[_c('ContentTypeLandingsection'),_c('ContentTypeAboutMe'),_c('ContentTypeServices'),_c('ContentTypeContact')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }